module.exports = __webpack_public_path__ + "static/about01-4f399c4d0bf3d1087233133eb336c87c.svg";